/* unplugin-vue-components disabled */import { render } from "./card-carousel.vue?vue&type=template&id=34a1e664&scoped=true"
import script from "./card-carousel.vue?vue&type=script&lang=js"
export * from "./card-carousel.vue?vue&type=script&lang=js"

import "./card-carousel.vue?vue&type=style&index=0&id=34a1e664&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a1e664"],['__file',"src/components/cards-v2/card-carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34a1e664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34a1e664', __exports__)) {
    api.reload('34a1e664', __exports__)
  }
  
  module.hot.accept("./card-carousel.vue?vue&type=template&id=34a1e664&scoped=true", () => {
    api.rerender('34a1e664', render)
  })

}


export default __exports__